export { default as TabBar } from './tab-bar'
export { default as Tab } from './tab'

export type { Props as TabBarProps } from './tab-bar'
export type { Props as TabProps } from './tab'
